module.exports = __webpack_public_path__ + "static/media/m120-31.ef734eb3.png";